(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './korge-root-korge-foundation.js', './kotlin-kotlin-stdlib.js', './korge-root-korlibs-datastructure.js', './korge-root-korge.js', './korge-root-korge-core.js', './korgee-korge-ldtk.js', './korge-root-korlibs-time.js', './korgee-korge-virtualcontroller.js', './korge-root-korlibs-logger.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./korge-root-korge-foundation.js'), require('./kotlin-kotlin-stdlib.js'), require('./korge-root-korlibs-datastructure.js'), require('./korge-root-korge.js'), require('./korge-root-korge-core.js'), require('./korgee-korge-ldtk.js'), require('./korge-root-korlibs-time.js'), require('./korgee-korge-virtualcontroller.js'), require('./korge-root-korlibs-logger.js'));
  else {
    if (typeof this['korge-root-korge-foundation'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korge-foundation' was not found. Please, check whether 'korge-root-korge-foundation' is loaded prior to 'korgee'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korgee'.");
    }
    if (typeof this['korge-root-korlibs-datastructure'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korlibs-datastructure' was not found. Please, check whether 'korge-root-korlibs-datastructure' is loaded prior to 'korgee'.");
    }
    if (typeof this['korge-root-korge'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korge' was not found. Please, check whether 'korge-root-korge' is loaded prior to 'korgee'.");
    }
    if (typeof this['korge-root-korge-core'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korge-core' was not found. Please, check whether 'korge-root-korge-core' is loaded prior to 'korgee'.");
    }
    if (typeof this['korgee-korge-ldtk'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korgee-korge-ldtk' was not found. Please, check whether 'korgee-korge-ldtk' is loaded prior to 'korgee'.");
    }
    if (typeof this['korge-root-korlibs-time'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korlibs-time' was not found. Please, check whether 'korge-root-korlibs-time' is loaded prior to 'korgee'.");
    }
    if (typeof this['korgee-korge-virtualcontroller'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korgee-korge-virtualcontroller' was not found. Please, check whether 'korgee-korge-virtualcontroller' is loaded prior to 'korgee'.");
    }
    if (typeof this['korge-root-korlibs-logger'] === 'undefined') {
      throw new Error("Error loading module 'korgee'. Its dependency 'korge-root-korlibs-logger' was not found. Please, check whether 'korge-root-korlibs-logger' is loaded prior to 'korgee'.");
    }
    root.korgee = factory(typeof korgee === 'undefined' ? {} : korgee, this['korge-root-korge-foundation'], this['kotlin-kotlin-stdlib'], this['korge-root-korlibs-datastructure'], this['korge-root-korge'], this['korge-root-korge-core'], this['korgee-korge-ldtk'], this['korge-root-korlibs-time'], this['korgee-korge-virtualcontroller'], this['korge-root-korlibs-logger']);
  }
}(this, function (_, kotlin_com_soywiz_korge_korge_foundation, kotlin_kotlin, kotlin_com_soywiz_korge_korlibs_datastructure, kotlin_com_soywiz_korge_korge, kotlin_com_soywiz_korge_korge_core, kotlin_korgee_korge_ldtk, kotlin_com_soywiz_korge_korlibs_time, kotlin_korgee_korge_virtualcontroller, kotlin_com_soywiz_korge_korlibs_logger) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var toFloat = kotlin_com_soywiz_korge_korge_foundation.$_$.g6;
  var Vector2F = kotlin_com_soywiz_korge_korge_foundation.$_$.y5;
  var toIntFloor = kotlin_com_soywiz_korge_korge_foundation.$_$.i6;
  var protoOf = kotlin_kotlin.$_$.uc;
  var toIntFloor_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.j6;
  var classMeta = kotlin_kotlin.$_$.jb;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var VOID = kotlin_kotlin.$_$.f;
  var SparseChunkedStackedIntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.t1;
  var emptyList = kotlin_kotlin.$_$.b7;
  var asReversed = kotlin_kotlin.$_$.y5;
  var copyOf = kotlin_kotlin.$_$.x6;
  var IntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.k1;
  var Companion_instance = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.s;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var Container = kotlin_com_soywiz_korge_korge.$_$.j1;
  var Bitmap32 = kotlin_com_soywiz_korge_korge_core.$_$.u1;
  var Companion_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.l1;
  var until = kotlin_kotlin.$_$.pd;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
  var RectangleI = kotlin_com_soywiz_korge_korge_foundation.$_$.t5;
  var slice = kotlin_com_soywiz_korge_korge_core.$_$.i2;
  var TileSetTileInfo = kotlin_com_soywiz_korge_korge_core.$_$.h3;
  var Colors_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.f1;
  var addTo = kotlin_com_soywiz_korge_korge.$_$.q1;
  var Size2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.r;
  var SolidRect = kotlin_com_soywiz_korge_korge.$_$.m1;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var Map = kotlin_kotlin.$_$.m5;
  var isInterface = kotlin_kotlin.$_$.gc;
  var StackedIntArray2 = kotlin_com_soywiz_korge_korlibs_datastructure.$_$.u1;
  var hasBitSet = kotlin_com_soywiz_korge_korge_foundation.$_$.ha;
  var _TileInfo___init__impl__kuhpkr = kotlin_com_soywiz_korge_korge.$_$.m;
  var _TileInfo___get_data__impl__56jsba = kotlin_com_soywiz_korge_korge.$_$.n;
  var ensureNotNull = kotlin_kotlin.$_$.ih;
  var TileMapRepeat_NONE_getInstance = kotlin_com_soywiz_korge_korge.$_$.i;
  var TileMap = kotlin_com_soywiz_korge_korge.$_$.h1;
  var numberToDouble = kotlin_kotlin.$_$.pc;
  var alpha = kotlin_com_soywiz_korge_korge.$_$.r1;
  var Nearest_getInstance = kotlin_com_soywiz_korge_korge.$_$.r;
  var get_filterScale = kotlin_com_soywiz_korge_korge.$_$.f1;
  var toList = kotlin_kotlin.$_$.p9;
  var Companion_instance_0 = kotlin_com_soywiz_korge_korge.$_$.q;
  var set_filter = kotlin_com_soywiz_korge_korge.$_$.e1;
  var set_filterScale = kotlin_com_soywiz_korge_korge.$_$.g1;
  var TileMap_init_$Create$ = kotlin_com_soywiz_korge_korge.$_$.l;
  var xy = kotlin_com_soywiz_korge_korge.$_$.x1;
  var mapCapacity = kotlin_kotlin.$_$.k8;
  var coerceAtLeast = kotlin_kotlin.$_$.hd;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var RectSlice = kotlin_com_soywiz_korge_korge_foundation.$_$.h4;
  var extract = kotlin_com_soywiz_korge_korge_core.$_$.g2;
  var CoroutineImpl = kotlin_kotlin.$_$.wa;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.fa;
  var Companion_getInstance_0 = kotlin_korgee_korge_ldtk.$_$.a;
  var readBitmap = kotlin_com_soywiz_korge_korge_core.$_$.g;
  var to = kotlin_kotlin.$_$.yh;
  var Companion_getInstance_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.n3;
  var Companion_getInstance_2 = kotlin_com_soywiz_korge_korge_foundation.$_$.e3;
  var times = kotlin_com_soywiz_korge_korge_foundation.$_$.f6;
  var Vector2D = kotlin_com_soywiz_korge_korge_foundation.$_$.x5;
  var Companion_getInstance_3 = kotlin_com_soywiz_korge_korge_foundation.$_$.p3;
  var applyScaleMode = kotlin_com_soywiz_korge_korge_foundation.$_$.a6;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.vh;
  var Vector2D_init_$Create$ = kotlin_com_soywiz_korge_korge_foundation.$_$.x;
  var Vector2D_init_$Create$_0 = kotlin_com_soywiz_korge_korge_foundation.$_$.u;
  var listOf = kotlin_kotlin.$_$.j8;
  var Collection = kotlin_kotlin.$_$.e5;
  var animator = kotlin_com_soywiz_korge_korge.$_$.u;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.j;
  var toDuration = kotlin_kotlin.$_$.zf;
  var Vector2D_init_$Create$_1 = kotlin_com_soywiz_korge_korge_foundation.$_$.w;
  var Size2D = kotlin_com_soywiz_korge_korge_foundation.$_$.v5;
  var isAlmostZero = kotlin_com_soywiz_korge_korge_foundation.$_$.g7;
  var _Frequency___get_timeSpan__impl__f9mrmt = kotlin_com_soywiz_korge_korlibs_time.$_$.d;
  var get_seconds = kotlin_com_soywiz_korge_korlibs_time.$_$.w;
  var Companion_getInstance_4 = kotlin_com_soywiz_korge_korge_foundation.$_$.r3;
  var toRatio = kotlin_com_soywiz_korge_korge_foundation.$_$.s6;
  var Companion_getInstance_5 = kotlin_com_soywiz_korge_korge_foundation.$_$.t3;
  var tween = kotlin_com_soywiz_korge_korge.$_$.w;
  var block = kotlin_com_soywiz_korge_korge.$_$.v;
  var onStageResized = kotlin_com_soywiz_korge_korge.$_$.v1;
  var MutableAtlas_init_$Create$ = kotlin_com_soywiz_korge_korge_core.$_$.l;
  var get_resourcesVfs = kotlin_com_soywiz_korge_korge_core.$_$.a4;
  var ASE_getInstance = kotlin_com_soywiz_korge_korge_core.$_$.i1;
  var toProps = kotlin_com_soywiz_korge_korge_core.$_$.y2;
  var readImageDataContainer = kotlin_com_soywiz_korge_korge_core.$_$.h;
  var ImageDataView = kotlin_com_soywiz_korge_korge.$_$.d1;
  var Anchor2D = kotlin_com_soywiz_korge_korge_foundation.$_$.h5;
  var anchor = kotlin_com_soywiz_korge_korge.$_$.s1;
  var xy_0 = kotlin_com_soywiz_korge_korge.$_$.w1;
  var Camera = kotlin_com_soywiz_korge_korge.$_$.i1;
  var Companion_instance_1 = kotlin_com_soywiz_korge_korge.$_$.s;
  var get_DefaultTtfFontAsBitmap = kotlin_com_soywiz_korge_korge_core.$_$.o2;
  var Companion_getInstance_6 = kotlin_com_soywiz_korge_korge_core.$_$.j1;
  var get_DefaultStringTextRenderer = kotlin_com_soywiz_korge_korge_core.$_$.c3;
  var Text = kotlin_com_soywiz_korge_korge.$_$.o1;
  var Companion_getInstance_7 = kotlin_korgee_korge_virtualcontroller.$_$.a;
  var listOf_0 = kotlin_kotlin.$_$.i8;
  var virtualController = kotlin_korgee_korge_virtualcontroller.$_$.b;
  var GameButton_BUTTON_SOUTH_getInstance = kotlin_com_soywiz_korge_korge.$_$.a;
  var GameButton_LX_getInstance = kotlin_com_soywiz_korge_korge.$_$.b;
  var get_hz = kotlin_com_soywiz_korge_korlibs_time.$_$.n;
  var addFixedUpdater = kotlin_com_soywiz_korge_korge.$_$.p1;
  var Scene = kotlin_com_soywiz_korge_korge.$_$.b1;
  var FixedSizeContainer = kotlin_com_soywiz_korge_korge.$_$.l1;
  var Stage = kotlin_com_soywiz_korge_korge.$_$.n1;
  var get_AlphaTransition = kotlin_com_soywiz_korge_korge.$_$.z;
  var withEasing = kotlin_com_soywiz_korge_korge.$_$.c1;
  var Companion_getInstance_8 = kotlin_com_soywiz_korge_korge_foundation.$_$.q3;
  var views = kotlin_com_soywiz_korge_korge.$_$.j;
  var findFirstAscendant = kotlin_com_soywiz_korge_korge.$_$.u1;
  var SceneContainer = kotlin_com_soywiz_korge_korge.$_$.a1;
  var getKClass = kotlin_kotlin.$_$.d;
  var Resources = kotlin_com_soywiz_korge_korge_core.$_$.n4;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var KClass = kotlin_kotlin.$_$.qd;
  var Companion_getInstance_9 = kotlin_com_soywiz_korge_korge.$_$.p;
  var Level_INFO_getInstance = kotlin_com_soywiz_korge_korlibs_logger.$_$.c;
  var KorgeDisplayMode = kotlin_com_soywiz_korge_korge.$_$.y1;
  var Korge = kotlin_com_soywiz_korge_korge.$_$.k;
  var get_EmptyContinuation = kotlin_kotlin.$_$.ia;
  //endregion
  //region block: pre-declaration
  setMetadataFor(LDTKCollisions, 'LDTKCollisions', classMeta);
  setMetadataFor(LDTKViewExt, 'LDTKViewExt', classMeta, Container);
  setMetadataFor(ExtTileset, 'ExtTileset', classMeta);
  setMetadataFor(LDTKWorld, 'LDTKWorld', classMeta);
  setMetadataFor($readLDTKWorldExtCOROUTINE$1, '$readLDTKWorldExtCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor(COLLISIONS, 'COLLISIONS', objectMeta);
  setMetadataFor($sceneMainCOROUTINE$3, '$sceneMainCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor(MyScene, 'MyScene', classMeta, Scene, VOID, MyScene, VOID, VOID, [0]);
  setMetadataFor(main$slambda, 'main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($mainCOROUTINE$2, '$mainCOROUTINE$2', classMeta, CoroutineImpl);
  //endregion
  var DO_EXTRUSION;
  function getLast(_this__u8e3s4, pos) {
    return _this__u8e3s4.b21(pos.s2l_1, pos.t2l_1);
  }
  function LDTKCollisions(world, stack) {
    this.zdq_1 = world;
    this.adr_1 = stack;
  }
  protoOf(LDTKCollisions).bdr = function (pixelPos) {
    // Inline function 'korlibs.math.geom.Vector2F.div' call
    var this_0 = toFloat(pixelPos);
    // Inline function 'korlibs.math.geom.Vector2F.div' call
    // Inline function 'korlibs.math.geom.Vector2F.div' call
    var scale = this.zdq_1.cdr_1.rde_1;
    var tmp$ret$2 = new Vector2F(this_0.a2o_1 / scale, this_0.b2o_1 / scale);
    return toIntFloor(tmp$ret$2);
  };
  protoOf(LDTKCollisions).fdr = function (tilePos) {
    return getLast(this.adr_1, tilePos);
  };
  protoOf(LDTKCollisions).gdr = function (pixelPos) {
    return this.fdr(this.bdr(pixelPos));
  };
  protoOf(LDTKCollisions).hdr = function (pixelPos) {
    return this.gdr(toIntFloor_0(pixelPos));
  };
  function createCollisionMaps(_this__u8e3s4, layerId) {
    layerId = layerId === VOID ? 'Collisions' : layerId;
    var ldtk = _this__u8e3s4.cdr_1;
    var world = new SparseChunkedStackedIntArray2();
    var tmp0_iterator = ldtk.fdf_1.u();
    while (tmp0_iterator.v()) {
      var level = tmp0_iterator.x();
      var tmp1_elvis_lhs = level.fdg_1;
      var tmp2_iterator = asReversed(tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs).u();
      $l$loop: while (tmp2_iterator.v()) {
        var layer = tmp2_iterator.x();
        if (!(layer.sdg_1 === layerId))
          continue $l$loop;
        var intGrid = new IntArray2(layer.qdg_1, layer.pdg_1, copyOf(layer.ddh_1, imul(layer.qdg_1, layer.pdg_1)));
        world.o20(Companion_instance.l21([intGrid], VOID, VOID, VOID, level.ldg_1 / ldtk.rde_1 | 0, level.mdg_1 / ldtk.rde_1 | 0));
      }
    }
    return new LDTKCollisions(_this__u8e3s4, world);
  }
  function LDTKViewExt(world, showCollisions) {
    showCollisions = showCollisions === VOID ? false : showCollisions;
    Container.call(this);
    this.qdt_1 = world;
    this.rdt_1 = showCollisions;
    var ldtk = this.qdt_1.cdr_1;
    var layersDefsById = this.qdt_1.edr_1;
    var tilesetDefsById = this.qdt_1.ddr_1;
    var colors = new Bitmap32(imul(ldtk.rde_1 + 4 | 0, 16), ldtk.rde_1);
    var tmp = Companion_getInstance();
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 16);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'LDTKViewExt.<anonymous>' call
      var tmp$ret$0 = new TileSetTileInfo(item, slice(colors, new RectangleI(imul(ldtk.rde_1 + 4 | 0, item), 0, ldtk.rde_1, ldtk.rde_1)));
      destination.r(tmp$ret$0);
    }
    var intsTileSet = tmp.p5e(destination);
    var tmp0_iterator_0 = ldtk.xde_1.ld8_1.u();
    while (tmp0_iterator_0.v()) {
      var layer = tmp0_iterator_0.x();
      var tmp1_iterator = layer.rda_1.u();
      while (tmp1_iterator.v()) {
        var value = tmp1_iterator.x();
        colors.t3k(Colors_getInstance().z3r(value.ldc_1), imul(ldtk.rde_1 + 4 | 0, value.ndc_1));
      }
    }
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = new Container(false);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'LDTKViewExt.<anonymous>' call
    var tmp0_iterator_1 = ldtk.fdf_1.u();
    while (tmp0_iterator_1.v()) {
      var level = tmp0_iterator_1.x();
      // Inline function 'korlibs.korge.view.xy' call
      // Inline function 'korlibs.korge.view.container' call
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = new Container(false);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, this_2);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'LDTKViewExt.<anonymous>.<anonymous>' call
      var tmp_0 = Colors_getInstance();
      var tmp0_elvis_lhs = level.wdf_1;
      var color = tmp_0.z3r(tmp0_elvis_lhs == null ? ldtk.qde_1 : tmp0_elvis_lhs);
      // Inline function 'korlibs.korge.view.solidRect' call
      var width = level.hdg_1;
      var height = level.gdg_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_5 = new SolidRect(Size2D_init_$Create$(width, height), color);
      // Inline function 'kotlin.apply' call
      addTo(this_5, this_4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
      var tmp1_elvis_lhs = level.fdg_1;
      var tmp2_iterator = asReversed(tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs).u();
      $l$loop_0: while (tmp2_iterator.v()) {
        var layer_0 = tmp2_iterator.x();
        var tmp3_elvis_lhs = layersDefsById.s2(layer_0.edh_1);
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var layerDef = tmp_1;
        // Inline function 'kotlin.collections.get' call
        var key = layer_0.wdg_1;
        var tmp4_elvis_lhs = (isInterface(tilesetDefsById, Map) ? tilesetDefsById : THROW_CCE()).s2(key);
        var tmp_2;
        if (tmp4_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_2 = tmp4_elvis_lhs;
        }
        var tilesetExt = tmp_2;
        var intGrid = new IntArray2(layer_0.qdg_1, layer_0.pdg_1, copyOf(layer_0.ddh_1, imul(layer_0.qdg_1, layer_0.pdg_1)));
        var tileData = new StackedIntArray2(layer_0.qdg_1, layer_0.pdg_1, -1);
        var tileset = tilesetExt.sdt_1;
        var gridSize = tileset.vdb_1;
        var tmp5_iterator = layer_0.zdg_1.u();
        while (tmp5_iterator.v()) {
          var tile = tmp5_iterator.x();
          var tmp6_container = tile.pdh_1;
          // Inline function 'kotlin.collections.component1' call
          var px = tmp6_container[0];
          // Inline function 'kotlin.collections.component2' call
          var py = tmp6_container[1];
          var tmp7_container = tile.qdh_1;
          // Inline function 'kotlin.collections.component1' call
          var tileX = tmp7_container[0];
          // Inline function 'kotlin.collections.component2' call
          var tileY = tmp7_container[1];
          var x = px / gridSize | 0;
          var y = py / gridSize | 0;
          var dx = px % gridSize | 0;
          var dy = py % gridSize | 0;
          var tx = tileX / gridSize | 0;
          var ty = tileY / gridSize | 0;
          var cellsTilesPerRow = tileset.pdb_1 / gridSize | 0;
          var tileId = imul(ty, cellsTilesPerRow) + tx | 0;
          var flipX = hasBitSet(tile.odh_1, 0);
          var flipY = hasBitSet(tile.odh_1, 1);
          tileData.o21(x, y, _TileInfo___get_data__impl__56jsba(_TileInfo___init__impl__kuhpkr(tileId, dx, dy, flipX, flipY)));
        }
        if (!(tilesetExt.tdt_1 == null)) {
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          // Inline function 'korlibs.korge.view.alpha' call
          // Inline function 'korlibs.korge.view.tiles.tileMap' call
          var tileset_0 = ensureNotNull(tilesetExt.tdt_1);
          var repeatX = TileMapRepeat_NONE_getInstance();
          var tileSize = tileset_0.g5f();
          // Inline function 'korlibs.korge.view.addTo' call
          var this_6 = (new TileMap(tileData, tileset_0, false, tileSize)).scs(repeatX, repeatX);
          // Inline function 'kotlin.apply' call
          var this_7 = addTo(this_6, this_4);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.tiles.tileMap.<anonymous>' call
          var alpha_0 = layerDef.ida_1;
          var this_8 = alpha(this_7, numberToDouble(alpha_0));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'LDTKViewExt.<anonymous>.<anonymous>.<anonymous>' call
          if (!DO_EXTRUSION) {
            // Inline function 'korlibs.korge.view.filter.filters' call
            var filters = [Nearest_getInstance()];
            var filterScale = get_filterScale(this_8);
            // Inline function 'korlibs.korge.view.filter.filters' call
            var filters_0 = toList(filters);
            var filterScale_0 = numberToDouble(filterScale);
            set_filter(this_8, Companion_instance_0.kcr(null, filters_0));
            set_filterScale(this_8, numberToDouble(filterScale_0));
          }
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'LDTKViewExt.<anonymous>.<anonymous>.<anonymous>' call
          this_8.gco_1 = 1;
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.also' call
          // Inline function 'korlibs.korge.view.visible' call
          // Inline function 'korlibs.korge.view.tiles.tileMap' call
          var repeatX_0 = TileMapRepeat_NONE_getInstance();
          var tileSize_0 = intsTileSet.g5f();
          // Inline function 'korlibs.korge.view.addTo' call
          var this_9 = TileMap_init_$Create$(intGrid, intsTileSet, false, tileSize_0).scs(repeatX_0, repeatX_0);
          // Inline function 'kotlin.apply' call
          var this_10 = addTo(this_9, this_4);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.tiles.tileMap.<anonymous>' call
          var visible = this.rdt_1;
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.visible.<anonymous>' call
          this_10.cax(visible);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'LDTKViewExt.<anonymous>.<anonymous>.<anonymous>' call
          if (!DO_EXTRUSION) {
            // Inline function 'korlibs.korge.view.filter.filters' call
            var filters_1 = [Nearest_getInstance()];
            var filterScale_1 = get_filterScale(this_10);
            // Inline function 'korlibs.korge.view.filter.filters' call
            var filters_2 = toList(filters_1);
            var filterScale_2 = numberToDouble(filterScale_1);
            set_filter(this_10, Companion_instance_0.kcr(null, filters_2));
            set_filterScale(this_10, numberToDouble(filterScale_2));
          }
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'LDTKViewExt.<anonymous>.<anonymous>.<anonymous>' call
          this_10.gco_1 = 1;
        }
      }
      var x_0 = level.ldg_1;
      var y_0 = level.mdg_1;
      xy(this_4, numberToDouble(x_0), numberToDouble(y_0));
    }
  }
  function ExtTileset(def, tileset) {
    this.sdt_1 = def;
    this.tdt_1 = tileset;
  }
  function LDTKWorld(ldtk, tilesetDefsById) {
    this.cdr_1 = ldtk;
    this.ddr_1 = tilesetDefsById;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.cdr_1.xde_1.ld8_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'LDTKWorld.layersDefsById.<anonymous>' call
      var tmp$ret$0 = element.cdb_1;
      destination.i2(tmp$ret$0, element);
    }
    tmp.edr_1 = destination;
  }
  function readLDTKWorldExt(_this__u8e3s4, $completion) {
    var tmp = new $readLDTKWorldExtCOROUTINE$1(_this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function extrude(_this__u8e3s4, border, mipmaps) {
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    // Inline function 'kotlin.collections.map' call
    var this_0 = _this__u8e3s4.h5f();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'extrude.<anonymous>' call
      var tmp$ret$0 = extract(item instanceof RectSlice ? item : THROW_CCE()).g3a();
      destination.r(tmp$ret$0);
    }
    var bitmaps = destination;
    return Companion_getInstance().x5e(_this__u8e3s4.a5f_1, _this__u8e3s4.b5f_1, bitmaps, border, mipmaps);
  }
  function $readLDTKWorldExtCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cdu_1 = _this__u8e3s4;
  }
  protoOf($readLDTKWorldExtCOROUTINE$1).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 6;
            this.ddu_1 = this.cdu_1;
            this.fd_1 = 1;
            suspendResult = this.ddu_1.f40(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.edu_1 = suspendResult;
            this.fdu_1 = Companion_getInstance_0().da5(this.edu_1);
            var tmp_0 = this;
            tmp_0.gdu_1 = this.fdu_1.xde_1.nd8_1;
            this.hdu_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this.gdu_1, 10)), 16);
            var tmp_1 = this;
            tmp_1.idu_1 = this.gdu_1;
            var tmp_2 = this;
            tmp_2.jdu_1 = LinkedHashMap_init_$Create$(this.hdu_1);
            this.kdu_1 = this.idu_1.u();
            this.fd_1 = 2;
            continue $sm;
          case 2:
            if (!this.kdu_1.v()) {
              this.fd_1 = 5;
              continue $sm;
            }

            this.ldu_1 = this.kdu_1.x();
            var tmp_3 = this;
            tmp_3.mdu_1 = this.jdu_1;
            var tmp_4 = this;
            tmp_4.ndu_1 = this.ldu_1;
            this.odu_1 = this.ndu_1.qdb_1;
            if (this.odu_1 == null) {
              this.pdu_1 = null;
              this.fd_1 = 4;
              continue $sm;
            } else {
              var tmp_5 = this;
              tmp_5.qdu_1 = this.odu_1;
              var tmp_6 = this;
              tmp_6.rdu_1 = this.qdu_1;
              this.fd_1 = 3;
              suspendResult = readBitmap(this.ddu_1.r40().s13(this.rdu_1), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            var bmp = suspendResult;
            this.pdu_1 = DO_EXTRUSION ? bmp.g3a() : bmp;
            this.fd_1 = 4;
            continue $sm;
          case 4:
            var bitmap = this.pdu_1;
            var tmp_7;
            if (bitmap == null) {
              tmp_7 = null;
            } else {
              var tset = Companion_getInstance().w5e(slice(bitmap), this.ndu_1.vdb_1, this.ndu_1.vdb_1);
              tmp_7 = DO_EXTRUSION ? extrude(tset, 2) : tset;
            }

            var tileSet = tmp_7;
            var pair = to(this.ndu_1.wdb_1, new ExtTileset(this.ndu_1, tileSet));
            this.mdu_1.i2(pair.ag_1, pair.bg_1);
            this.fd_1 = 2;
            continue $sm;
          case 5:
            var tilesetDefsById = this.jdu_1;
            return new LDTKWorld(this.fdu_1, tilesetDefsById);
          case 6:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 6) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function normalizeAlmostZero(_this__u8e3s4, epsilon) {
    var tmp;
    // Inline function 'kotlin.math.absoluteValue' call
    if (Math.abs(_this__u8e3s4) < epsilon) {
      tmp = 0.0;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function interpolate(_this__u8e3s4, l, r) {
    return Companion_getInstance_1().w2k(l, r, _this__u8e3s4);
  }
  function getRectWithAnchor(_this__u8e3s4, pos, size, anchor) {
    anchor = anchor === VOID ? Companion_getInstance_2().o2c() : anchor;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var that = times(size, anchor);
    var topLeft = new Vector2D(pos.g28_1 - that.g28_1, pos.h28_1 - that.h28_1);
    return Companion_getInstance_1().f2e(topLeft, size);
  }
  function getRectWithAnchorClamped(_this__u8e3s4, pos, size, anchor, clampBounds, keepProportions) {
    anchor = anchor === VOID ? Companion_getInstance_2().o2c() : anchor;
    keepProportions = keepProportions === VOID ? true : keepProportions;
    var rect = getRectWithAnchor(_this__u8e3s4, pos, size, anchor);
    if (rect.s2d() > clampBounds.s2d())
      rect = rect.o2l(rect.l2d_1 - (rect.s2d() - clampBounds.s2d()));
    if (rect.u2d() > clampBounds.u2d())
      rect = rect.o2l(VOID, rect.m2d_1 - (rect.u2d() - clampBounds.u2d()));
    if (rect.r2d() < clampBounds.r2d())
      rect = rect.o2l(rect.l2d_1 - (rect.r2d() - clampBounds.r2d()));
    if (rect.t2d() < clampBounds.t2d())
      rect = rect.o2l(VOID, rect.m2d_1 - (rect.t2d() - clampBounds.t2d()));
    return (rect.s2d() > clampBounds.s2d() ? true : rect.u2d() > clampBounds.u2d()) ? applyScaleMode(rect, clampBounds, Companion_getInstance_3().k2m_1, Companion_getInstance_2().f2c_1) : rect;
  }
  function main($completion) {
    var tmp = new $mainCOROUTINE$2($completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  }
  function COLLISIONS() {
    this.ddv_1 = -1;
    this.edv_1 = 0;
    this.fdv_1 = 1;
    this.gdv_1 = 2;
    this.hdv_1 = 3;
  }
  protoOf(COLLISIONS).idv = function (type, direction) {
    switch (type) {
      case 1:
      case 3:
        return true;
      default:
        return type === -1;
    }
  };
  protoOf(COLLISIONS).jdv = function (type, direction) {
    return type === 2;
  };
  var COLLISIONS_instance;
  function COLLISIONS_getInstance() {
    return COLLISIONS_instance;
  }
  function _get_characters__vyrtlr($this) {
    var tmp = $this.ydv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('characters');
    }
  }
  function sceneMain$tryMoveDeltaX(this$0, collisions, delta) {
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var this_0 = this$0.adw().n46();
    var newPos = new Vector2D(this_0.g28_1 + delta.g28_1, this_0.h28_1 + delta.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D_init_$Create$(-12, 14);
    var tmp = new Vector2D(newPos.g28_1 + that.g28_1, newPos.h28_1 + that.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_0 = Vector2D_init_$Create$(12, 14);
    var tmp_0 = new Vector2D(newPos.g28_1 + that_0.g28_1, newPos.h28_1 + that_0.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_1 = Vector2D_init_$Create$_0(-12, 28.5);
    var tmp_1 = new Vector2D(newPos.g28_1 + that_1.g28_1, newPos.h28_1 + that_1.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_2 = Vector2D_init_$Create$_0(12, 28.5);
    var tmp$ret$4 = new Vector2D(newPos.g28_1 + that_2.g28_1, newPos.h28_1 + that_2.h28_1);
    var collisionPoints = listOf([tmp, tmp_0, tmp_1, tmp$ret$4]);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_2;
      if (isInterface(collisionPoints, Collection)) {
        tmp_2 = collisionPoints.b1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator = collisionPoints.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'MyScene.sceneMain.tryMoveDeltaX.<anonymous>' call
        if (!!COLLISIONS_instance.idv(collisions.hdr(element), delta)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    var set = tmp$ret$5;
    if (set) {
      this$0.adw().u46(newPos);
      this$0.udv_1 = newPos;
    }
    return set;
  }
  function sceneMain$tryMoveDeltaY(this$0, collisions, climbing, delta) {
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var this_0 = this$0.adw().n46();
    var newPos = new Vector2D(this_0.g28_1 + delta.g28_1, this_0.h28_1 + delta.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D_init_$Create$(-6, 29);
    var tmp = new Vector2D(newPos.g28_1 + that.g28_1, newPos.h28_1 + that.h28_1);
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that_0 = Vector2D_init_$Create$(6, 29);
    var tmp$ret$2 = new Vector2D(newPos.g28_1 + that_0.g28_1, newPos.h28_1 + that_0.h28_1);
    var collisionPoints = listOf([tmp, tmp$ret$2]);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(collisionPoints, Collection)) {
        tmp_0 = collisionPoints.b1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$3 = true;
        break $l$block_0;
      }
      var tmp0_iterator = collisionPoints.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'MyScene.sceneMain.tryMoveDeltaY.<anonymous>' call
        if (!COLLISIONS_instance.jdv(collisions.hdr(element), delta)) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
      }
      tmp$ret$3 = true;
    }
    var set = tmp$ret$3;
    if (set) {
      this$0.adw().u46(newPos);
      this$0.udv_1 = newPos;
      climbing._v = true;
    }
    return set;
  }
  function sceneMain$setState(playerState, $this_sceneMain, this$0, name, time) {
    if (!(playerState._v === name)) {
      playerState._v = name;
      animator($this_sceneMain, VOID, VOID, VOID, VOID, VOID, VOID, MyScene$sceneMain$setState$lambda(time, this$0, playerState));
    }
  }
  function sceneMain$updateState(jumping, climbing, walking, playerState, $this_sceneMain, this$0) {
    if (jumping._v) {
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$0 = toDuration(0.1, DurationUnit_SECONDS_getInstance());
      sceneMain$setState(playerState, $this_sceneMain, this$0, 'jumping', tmp$ret$0);
    } else if (climbing._v) {
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0.1, DurationUnit_SECONDS_getInstance());
      sceneMain$setState(playerState, $this_sceneMain, this$0, 'climbing', tmp$ret$1);
    } else if (walking._v) {
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$2 = toDuration(0.1, DurationUnit_SECONDS_getInstance());
      sceneMain$setState(playerState, $this_sceneMain, this$0, 'walking', tmp$ret$2);
    } else {
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$3 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
      sceneMain$setState(playerState, $this_sceneMain, this$0, 'idle', tmp$ret$3);
    }
  }
  function sceneMain$updated(this$0, climbing, walking, collisions, jumping, playerState, $this_sceneMain, left, right, up, down, midAir, scale) {
    if (!midAir) {
      if (left ? true : right) {
        var tmp = this$0.adw();
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = this$0.adw().maw();
        var tmp$ret$0 = Math.abs(this_0);
        tmp.law(tmp$ret$0 * (right ? 1.0 : -1.0));
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_1 = Vector2D_init_$Create$_1(2.0, 0);
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var scale_0 = right ? 1 : -1;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_2 = new Vector2D(this_1.g28_1 * scale_0, this_1.h28_1 * scale_0);
        var tmp$ret$4 = new Vector2D(this_2.g28_1 * scale, this_2.h28_1 * scale);
        sceneMain$tryMoveDeltaX(this$0, collisions, tmp$ret$4);
        this$0.adw().l9h_1 = 2.0 * scale;
        climbing._v = false;
        walking._v = true;
      } else if (up ? true : down) {
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_3 = Vector2D_init_$Create$_0(0, 0.7);
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var scale_1 = up ? -1 : 1;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_4 = new Vector2D(this_3.g28_1 * scale_1, this_3.h28_1 * scale_1);
        var tmp$ret$8 = new Vector2D(this_4.g28_1 * scale, this_4.h28_1 * scale);
        sceneMain$tryMoveDeltaY(this$0, collisions, climbing, tmp$ret$8);
        this$0.adw().l9h_1 = 0.7 * scale;
        walking._v = false;
      }
    } else {
      this$0.adw().l9h_1 = 1.0;
      climbing._v = false;
      walking._v = false;
    }
    sceneMain$updateState(jumping, climbing, walking, playerState, $this_sceneMain, this$0);
  }
  function sceneMain$createSize($this_sceneMain, zoom) {
    return new Size2D(zoom * ($this_sceneMain.x1q() / $this_sceneMain.y1q()), zoom);
  }
  function MyScene$sceneMain$lambda($this_sceneMain, $immediateSetCamera) {
    return function ($this$onStageResized, width, height) {
      $this_sceneMain.vaw(Size2D_init_$Create$($this$onStageResized.d9f_1.jaa(), $this$onStageResized.d9f_1.iaa()));
      $immediateSetCamera._v = true;
      return Unit_instance;
    };
  }
  function MyScene$sceneMain$lambda_0($playerSpeed, $jumping, $climbing, $walking, $playerState, $this_sceneMain, this$0) {
    return function () {
      var isInGround = isAlmostZero($playerSpeed._v.h28_1);
      var tmp;
      if (isInGround) {
        if (!$jumping._v) {
          $jumping._v = true;
          sceneMain$updateState($jumping, $climbing, $walking, $playerState, $this_sceneMain, this$0);
        }
        // Inline function 'korlibs.math.geom.Vector2D.plus' call
        var this_0 = $playerSpeed._v;
        var that = Vector2D_init_$Create$_0(0, -5.5);
        var tmp$ret$0 = new Vector2D(this_0.g28_1 + that.g28_1, this_0.h28_1 + that.h28_1);
        $playerSpeed._v = tmp$ret$0;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MyScene$sceneMain$lambda_1(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain) {
    return function (it) {
      var tmp;
      if (normalizeAlmostZero(it.ldk_1, 0.075) === 0.0) {
        sceneMain$updated(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain, it.ldk_1 < 0.0, it.ldk_1 > 0.0, false, false, true, 1.0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MyScene$sceneMain$lambda_2($virtualController, $playerSpeed, this$0, $FREQ, $jumping, $mapBounds, $immediateSetCamera, $currentRect, $camera, $climbing, $walking, $collisions, $playerState, $this_sceneMain) {
    return function ($this$addFixedUpdater) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var lx = normalizeAlmostZero($virtualController.tdk(), 0.075);
      var ly = normalizeAlmostZero($virtualController.udk(), 0.075);
      var tmp;
      if (lx < 0.0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$0 = Math.abs(lx);
        sceneMain$updated(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain, true, false, false, false, false, tmp$ret$0);
        tmp = Unit_instance;
      } else if (lx > 0.0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$1 = Math.abs(lx);
        sceneMain$updated(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain, false, true, false, false, false, tmp$ret$1);
        tmp = Unit_instance;
      } else if (ly < 0.0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$2 = Math.abs(ly);
        sceneMain$updated(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain, false, false, true, false, false, tmp$ret$2);
        tmp = Unit_instance;
      } else if (ly > 0.0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$3 = Math.abs(ly);
        sceneMain$updated(this$0, $climbing, $walking, $collisions, $jumping, $playerState, $this_sceneMain, false, false, false, true, false, tmp$ret$3);
        tmp = Unit_instance;
      }
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (!sceneMain$tryMoveDeltaY(this$0, $collisions, $climbing, $playerSpeed._v)) {
        // Inline function 'korlibs.math.geom.Vector2D.plus' call
        var this_0 = $playerSpeed._v;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        var this_1 = this$0.xdv_1;
        var scale = get_seconds(_Frequency___get_timeSpan__impl__f9mrmt($FREQ));
        var that = new Vector2D(this_1.g28_1 * scale, this_1.h28_1 * scale);
        var tmp$ret$6 = new Vector2D(this_0.g28_1 + that.g28_1, this_0.h28_1 + that.h28_1);
        $playerSpeed._v = tmp$ret$6;
      }
      var tmp_0;
      if (!sceneMain$tryMoveDeltaX(this$0, $collisions, $playerSpeed._v) ? !sceneMain$tryMoveDeltaY(this$0, $collisions, $climbing, $playerSpeed._v) : false) {
        $playerSpeed._v = Companion_getInstance_4().d2d_1;
        var tmp_1;
        if ($jumping._v) {
          $jumping._v = false;
          sceneMain$updateState($jumping, $climbing, $walking, $playerState, $this_sceneMain, this$0);
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      }
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var newRect = getRectWithAnchorClamped(Companion_getInstance_1(), this$0.adw().n46(), sceneMain$createSize($this_sceneMain, this$0.wdv_1), Companion_getInstance_2().o2c(), $mapBounds);
      if ($immediateSetCamera._v) {
        $immediateSetCamera._v = false;
        $currentRect._v = newRect;
      }
      $currentRect._v = interpolate(toRatio(0.025), $currentRect._v, newRect);
      $camera.ybf($currentRect._v);
      this$0.vdv_1 = this$0.wdv_1;
      return Unit_instance;
    };
  }
  function MyScene$sceneMain$setState$lambda$lambda(this$0, $playerState) {
    return function () {
      this$0.adw().jcr($playerState._v);
      return Unit_instance;
    };
  }
  function MyScene$sceneMain$setState$lambda($time, this$0, $playerState) {
    return function ($this$animator) {
      tween($this$animator, [], $time, Companion_getInstance_5().l28());
      block($this$animator, VOID, MyScene$sceneMain$setState$lambda$lambda(this$0, $playerState));
      return Unit_instance;
    };
  }
  function $sceneMainCOROUTINE$3(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jdw_1 = _this__u8e3s4;
    this.kdw_1 = _this__u8e3s4_0;
  }
  protoOf($sceneMainCOROUTINE$3).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            this.ldw_1 = {_v: false};
            onStageResized(this.kdw_1, VOID, MyScene$sceneMain$lambda(this.kdw_1, this.ldw_1));
            this.mdw_1 = MutableAtlas_init_$Create$();
            this.fd_1 = 1;
            suspendResult = readLDTKWorldExt(get_resourcesVfs().s13('ldtk/Typical_2D_platformer_example.ldtk'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ndw_1 = suspendResult;
            this.odw_1 = createCollisionMaps(this.ndw_1);
            this.pdw_1 = new LDTKViewExt(this.ndw_1, false);
            this.fd_1 = 2;
            suspendResult = readImageDataContainer(get_resourcesVfs().s13('chumbo.ase'), toProps(ASE_getInstance()), this.mdw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.jdw_1.ydv_1 = ARGUMENT;
            var tmp_0 = this.jdw_1;
            var this_0 = this.kdw_1;
            var data = _get_characters__vyrtlr(this.jdw_1).g51('chumbo');
            var this_1 = new ImageDataView(data, 'idle', true, false);
            var this_2 = addTo(this_1, this_0);
            anchor(this_2, new Anchor2D(numberToDouble(0.5), numberToDouble(0.0)));
            xy_0(this_2, this.jdw_1.udv_1);
            tmp_0.zdv_1 = this_2;
            var this_3 = this.kdw_1;
            var this_4 = new Camera();
            var this_5 = addTo(this_4, this_3);
            this_5.pag(this.pdw_1);
            this_5.pag(this.jdw_1.adw());
            var camera = this_5;
            var this_6 = this.kdw_1;
            var text = "Use the arrow keys '<-' '->' to move Chumbo\nSpace for jumping";
            var textSize = Companion_instance_1.fca_1;
            var color = Colors_getInstance().l3b_1;
            var font = get_DefaultTtfFontAsBitmap();
            var alignment = Companion_getInstance_6().i42_1;
            var renderer = get_DefaultStringTextRenderer();
            var autoScaling = Companion_instance_1.gca_1;
            var this_7 = new Text(text, numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
            var this_8 = addTo(this_7, this_6);
            xy(this_8, numberToDouble(8), numberToDouble(8));
            var buttonRadius = 110.0;
            var this_9 = virtualController(this.kdw_1, VOID, listOf_0(Companion_getInstance_7().adl_1), buttonRadius);
            alpha(this_9.odk_1, 0.5);
            var virtualController_0 = this_9;
            var playerSpeed = {_v: Vector2D_init_$Create$(0, 0)};
            var mapBounds = this.pdw_1.may();
            var climbing = {_v: false};
            var playerState = {_v: 'idle'};
            var jumping = {_v: false};
            var walking = {_v: false};
            var tmp_1 = GameButton_BUTTON_SOUTH_getInstance();
            virtualController_0.xdk(tmp_1, MyScene$sceneMain$lambda_0(playerSpeed, jumping, climbing, walking, playerState, this.kdw_1, this.jdw_1));
            var tmp_2 = GameButton_LX_getInstance();
            virtualController_0.wdk(tmp_2, MyScene$sceneMain$lambda_1(this.jdw_1, climbing, walking, this.odw_1, jumping, playerState, this.kdw_1));
            var currentRect = {_v: getRectWithAnchorClamped(Companion_getInstance_1(), this.jdw_1.adw().n46(), sceneMain$createSize(this.kdw_1, this.jdw_1.vdv_1), Companion_getInstance_2().o2c(), mapBounds)};
            var FREQ = get_hz(60);
            addFixedUpdater(this.kdw_1, FREQ, VOID, VOID, MyScene$sceneMain$lambda_2(virtualController_0, playerSpeed, this.jdw_1, FREQ, jumping, mapBounds, this.ldw_1, currentRect, camera, climbing, walking, this.odw_1, playerState, this.kdw_1));
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  function MyScene() {
    Scene.call(this);
    this.udv_1 = Vector2D_init_$Create$(200, 150);
    this.vdv_1 = 32.0;
    this.wdv_1 = 128.0;
    this.xdv_1 = Vector2D_init_$Create$(0, 10);
  }
  protoOf(MyScene).adw = function () {
    var tmp = this.zdv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('player');
    }
  };
  protoOf(MyScene).dah = function (_this__u8e3s4, $completion) {
    var tmp = new $sceneMainCOROUTINE$3(this, _this__u8e3s4, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  function main$slambda$lambda(it) {
    return it instanceof FixedSizeContainer;
  }
  function main$slambda$lambda_0($sceneInjector) {
    return function ($this$mapPrototype) {
      // Inline function 'main.<anonymous>.<anonymous>' call
      return new MyScene();
    };
  }
  function main$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda).r9a = function ($this$Korge, $completion) {
    var tmp = this.s9a($this$Korge, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(main$slambda).ne = function (p1, $completion) {
    return this.r9a(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 3;
            var tmp_0 = this;
            tmp_0.zdw_1 = this.ydw_1;
            var tmp_1 = this;
            tmp_1.adx_1 = withEasing(get_AlphaTransition(), Companion_getInstance_5().m28());
            var tmp_2 = this;
            tmp_2.bdx_1 = 'sceneContainer';
            var tmp_3 = this;
            tmp_3.cdx_1 = Companion_getInstance_8().t2m_1;
            var tmp_4 = this;
            tmp_4.ddx_1 = this.zdw_1;
            this.fd_1 = 1;
            suspendResult = views(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.edx_1 = suspendResult;
            var tmp_5 = this;
            tmp_5.fdx_1 = this.adx_1;
            var tmp_6 = this;
            tmp_6.gdx_1 = this.bdx_1;
            var tmp_7 = this;
            tmp_7.hdx_1 = this.cdx_1;
            this.idx_1 = this.hdx_1;
            this.jdx_1 = this.idx_1.cg();
            this.kdx_1 = this.idx_1.dg();
            this.ldx_1 = this.jdx_1;
            this.mdx_1 = this.kdx_1;
            if (this.jdx_1 === 0.0 ? this.kdx_1 === 0.0 : false) {
              var tmp_8 = findFirstAscendant(this.ddx_1, main$slambda$lambda);
              var base = (tmp_8 == null ? true : tmp_8 instanceof FixedSizeContainer) ? tmp_8 : null;
              var tmp_9 = this;
              var tmp2_elvis_lhs = base == null ? null : base.x1q();
              tmp_9.ldx_1 = tmp2_elvis_lhs == null ? this.edx_1.c9g_1.x1q() : tmp2_elvis_lhs;
              var tmp_10 = this;
              var tmp4_elvis_lhs = base == null ? null : base.y1q();
              tmp_10.mdx_1 = tmp4_elvis_lhs == null ? this.edx_1.c9g_1.y1q() : tmp4_elvis_lhs;
            }

            var tmp_11 = this;
            var this_0 = new SceneContainer(this.edx_1, this.fdx_1, this.gdx_1, new Size2D(this.ldx_1, this.mdx_1));
            var instance = this.ddx_1;
            tmp_11.ndx_1 = addTo(this_0, instance);
            var tmp_12 = this;
            tmp_12.odx_1 = this.ndx_1;
            var tmp_13 = this;
            tmp_13.pdx_1 = [];
            var tmp_14 = this;
            tmp_14.qdx_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
            var tmp_15 = this;
            tmp_15.rdx_1 = this.odx_1.u9l_1;
            var tmp_16 = this;
            tmp_16.sdx_1 = this.odx_1;
            var tmp_17 = this;
            tmp_17.tdx_1 = getKClass(MyScene);
            var tmp_18 = this;
            tmp_18.udx_1 = this.pdx_1.slice();
            var tmp_19 = this;
            tmp_19.vdx_1 = this.qdx_1;
            var tmp_20 = this;
            tmp_20.wdx_1 = this.rdx_1;
            var tmp_21 = this;
            tmp_21.xdx_1 = true;
            this.ydx_1 = this.sdx_1.t9l_1.r9e_1.j27().h27(getKClass(SceneContainer), this.sdx_1).h27(getKClass(Resources), new Resources(this.sdx_1.w1a(), this.sdx_1.t9l_1.r9u().a6n_1, this.sdx_1.t9l_1.r9u()));
            var this_1 = this.udx_1;
            var n = 0;
            while (n < this_1.length) {
              var tmp0 = n;
              n = tmp0 + 1 | 0;
              var inject = this_1[tmp0];
              var tmp_22 = getKClassFromExpression(inject);
              this.ydx_1.h27(isInterface(tmp_22, KClass) ? tmp_22 : THROW_CCE(), inject);
            }

            var tmp_23 = this;
            this.ydx_1;
            tmp_23.zdx_1 = new MyScene();
            var this_2 = Companion_getInstance_9().xai_1;
            var level = Level_INFO_getInstance();
            if (this_2.f25(level)) {
              this_2.g25(level, 'Changing scene to... ' + this.tdx_1 + ' ... ' + this.zdx_1);
            }

            if (this.xdx_1) {
              this.zdx_1.s27(this.ydx_1);
              var tmp_24 = getKClassFromExpression(this.zdx_1);
              var tmp_25 = isInterface(tmp_24, KClass) ? tmp_24 : THROW_CCE();
              this.sdx_1.t9l_1.r9e_1.l27(tmp_25, main$slambda$lambda_0(this.ydx_1));
            }

            this.fd_1 = 2;
            suspendResult = this.sdx_1.vaj(this.zdx_1, this.vdx_1, this.wdx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 3) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(main$slambda).s9a = function ($this$Korge, completion) {
    var i = new main$slambda(completion);
    i.ydw_1 = $this$Korge;
    return i;
  };
  function main$slambda_0(resultContinuation) {
    var i = new main$slambda(resultContinuation);
    var l = function ($this$Korge, $completion) {
      return i.r9a($this$Korge, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $mainCOROUTINE$2(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($mainCOROUTINE$2).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 2;
            this.adv_1 = Size2D_init_$Create$(512, 512);
            this.bdv_1 = Colors_getInstance().z3r('#2b2b2b');
            this.cdv_1 = new KorgeDisplayMode(Companion_getInstance_3().l2m_1, Companion_getInstance_2().f2c_1, false);
            this.fd_1 = 1;
            suspendResult = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.adv_1, VOID, VOID, VOID, VOID, VOID, VOID, this.cdv_1, 'Korge Platformer', VOID, this.bdv_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 2) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  //region block: init
  DO_EXTRUSION = true;
  COLLISIONS_instance = new COLLISIONS();
  //endregion
  //region block: exports
  kotlin_com_soywiz_korge_korge_core.$jsExportAll$(_);
  //endregion
  main(get_EmptyContinuation());
  return _;
}));
